module.exports = __webpack_public_path__ + "img/undraw_done_checking.571c2373.svg";